import { signal } from '@angular/core';
import type * as mapboxgl from 'mapbox-gl';
import type { AppId } from '../../../model';
import { WhispDebugView } from './whisp-debug';
import { WhispDebugLayerController } from './whisp-debug-layer';

export interface WhispDebugSource {
  load(siteId: AppId): Promise<WhispDebugView | null>;
}

export class WhispDebugController {
  readonly view = signal<WhispDebugView | null>(null);
  readonly selectedPartId = signal<string | null>(null);
  private layer: WhispDebugLayerController | null = null;
  private visible = false;

  constructor(
    private readonly map: () => mapboxgl.Map | undefined,
    private readonly source: WhispDebugSource
  ) {}

  get loadedFindingId(): string | null {
    return this.view()?.findingId ?? null;
  }

  async load(siteId: AppId): Promise<void> {
    const view = await this.source.load(siteId);
    this.view.set(view);
    this.selectedPartId.set(null);
    if (view) this.layerOf()?.show(view, this.visible);
    else this.layer?.clear();
  }

  select(partId: string): void {
    this.selectedPartId.set(partId);
    this.layer?.select(partId);
  }

  setVisible(visible: boolean): void {
    this.visible = visible;
    this.layer?.setVisible(visible);
  }

  clear(): void {
    this.view.set(null);
    this.selectedPartId.set(null);
    this.layer?.clear();
  }

  private layerOf(): WhispDebugLayerController | null {
    const map = this.map();
    if (!map) return null;
    this.layer ??= new WhispDebugLayerController(map, (partId) => this.select(partId));
    return this.layer;
  }
}
